import StickyProfileHeader from "./StickyProfileHeader";

export default StickyProfileHeader;
